<template>
    <div id="app">
        <header>
            <div class="header-mobile">
                <div class="tw-flex tw-items-center tw-justify-center tw-py-2">
                    <img class="phone_white" src="~@/assets/img/icons/phone_white.svg">
                    <p class="text-mobile tw-px-2"> GET A FREE QUOTE</p>
                    <p class="number-mobile">(877)-360-3843</p>
                </div>
            </div>
            <div class="tw-container tw-flex tw-items-center tw-py-3 lg:tw-justify-between lg:tw-pt-6 lg:tw-pb-4">
                <img class="logo" src="~@/assets/img/logo.svg">
                <div class="right-header">
                    <div class="tw-grid tw-grid-cols-2 tw-items-center">
                        <div class="tw-ml-auto tw-pr-3">
                            <img class="phone_header" src="~@/assets/img/icons/phone_header.svg">
                        </div>
                        <div class="">
                            <p>GET A <span>FREE QUOTE</span></p>
                            <p class="phone_number">(877)-360-3843</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <main>
            <div class="lg:tw-container">
                <div class="hero-mobile tw-text-center tw-pt-6 tw-pb-5 lg:tw-pt-24">
                    <h1>Protection starts <br class="lg:tw-hidden">with prevention</h1>
                    <h2>Smart Security, Professionally Installed</h2>
                </div>
                <div class="lg:tw-pb-24">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" >
                    </FormSuccess>
                </div>
            </div>
        </main>

        <section class="gadgets tw-container tw-text-center tw-pt-8 tw-pb-5 lg:tw-py-16">
            <h2>Your home is <span>unique</span></h2>
            <p>Your smart security system should be too!</p>
            <img class="alarm" src="~@/assets/img/icons/alarm.svg">
            <p>With a smart home security system where everything works together, you can control your devices <strong>from anywhere</strong> on one app.<br>And with <strong>24/7 monitoring and support</strong>, your home and family are always protected.</p>
            <img class="gadgets" src="~@/assets/img/gadgets.jpg">
        </section>

        <section class="advertising">
            <div class="tw-container tw-text-center tw-pt-8 tw-pb-10 lg:tw-py-12">
                <h2>Professional Installation and $0 Activation. Call now.</h2>
                <div class="tw-text-center tw-mt-5">
                    <button
                        type="button"
                        class="btn-adv animate__animated animate__pulse"
                        @click="scrollTo('form')"
                    >
                        (877)-360-3843
                    </button>
                </div>
            </div>
        </section>

        <section class="customers">
            <div class="tw-container tw-py-10 lg:tw-pt-16 lg:tw-pb-20">
                <h2>What our customers<br class="lg:tw-hidden"> are <span>saying</span></h2>
                <div class="mobile-rate tw-pt-4">
                    <div class="glide section__slider tw-h-full tw-relative">
                        <div class="glide__track tw-h-full" data-glide-el="track">
                            <ul class="glide__slides tw-h-full">
                                <li class="glide__slide slide">
                                    <div class="cards tw-px-6 tw-mx-auto">
                                        <h3>Michael Atkinson</h3>
                                        <img src="~@/assets/img/icons/rate.svg">
                                        <p>I like the system that I have. It was installed by the previous owner. I know that it keeps negative things from happening around my house.</p>
                                    </div>
                                </li>
                                <li class="glide__slide slide">
                                    <div class="cards tw-px-6 tw-mx-auto">
                                        <h3>Wilbert Early</h3>
                                        <img src="~@/assets/img/icons/rate.svg">
                                        <p>Great service and technicians were timely and very professional during the install and explaining the operation of equipment.</p>
                                    </div>
                                </li>
                                <li class="glide__slide slide">
                                    <div class="cards tw-px-6 tw-mx-auto">
                                        <h3>Brumeljr</h3>
                                        <img src="~@/assets/img/icons/rate.svg">
                                        <p>This system makes our old alarm system seem so prehistoric. The best features for me are the cameras. I can talk directly to whomever is …</p>
                                    </div>
                                </li>
                                <li class="glide__slide slide">
                                    <div class="cards tw-px-6 tw-mx-auto">
                                        <h3>Nick Kontsalakis</h3>
                                        <img src="~@/assets/img/icons/rate.svg">
                                        <p>First off the customer service was wonderful as I set up the appointments and settled on the system I was to use. A slight hiccup on the day of …</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="glide__arrows tw-text-center" data-glide-el="controls">
                                <button class="btn-prev" data-glide-dir="<"></button>
                                <button class="btn-next" data-glide-dir=">"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="desktop-rate tw-grid tw-grid-cols-4 tw-pt-10 tw-gap-4">
                    <div class="cards lg:tw-px-6">
                        <h3>Michael Atkinson</h3>
                        <img src="~@/assets/img/icons/rate.svg">
                        <p>I like the system that I have. It was installed by the previous owner. I know that it keeps negative things from happening around my house.</p>
                    </div>
                    <div class="cards lg:tw-px-6">
                        <h3>Wilbert Early</h3>
                        <img src="~@/assets/img/icons/rate.svg">
                        <p>Great service and technicians were timely and very professional during the install and explaining the operation of equipment.</p>
                    </div>
                    <div class="cards lg:tw-px-6">
                        <h3>Brumeljr</h3>
                        <img src="~@/assets/img/icons/rate.svg">
                        <p>This system makes our old alarm system seem so prehistoric. The best features for me are the cameras. I can talk directly to whomever is …</p>
                    </div>
                    <div class="cards lg:tw-px-6">
                        <h3>Nick Kontsalakis</h3>
                        <img src="~@/assets/img/icons/rate.svg">
                        <p>First off the customer service was wonderful as I set up the appointments and settled on the system I was to use. A slight hiccup on the day of …</p>
                    </div>
                </div>
            </div>
        </section>

        <footer>
            <div class="tw-container tw-text-center tw-pt-8 tw-pb-10 lg:tw-py-12">
                <h2>Call now to get a free quote.</h2>
                <div class="tw-text-center tw-mt-5">
                    <button
                        type="button"
                        class="btn-adv animate__animated animate__pulse"
                        @click="scrollTo('form')"
                    >
                        (877)-360-3843
                    </button>
                </div>
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

    </div>
</template>

<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Glide, { Controls, Autoplay, Swipe } from '@glidejs/glide/dist/glide.modular.esm';

export default {
    components: {
        Form,
        FormSuccess,
        ModalContainer,
        Terms,
    },
    methods: {
        scrollTo(target) {
            document.querySelector(`${target}`).scrollIntoView({
                behavior: 'smooth',
            });
        },
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
        new Glide('.section__slider', {
            autoplay: 5000,
            gap: 0,
        }).mount({ Autoplay, Controls, Swipe });

        const data = {
            url: window.location.hostname,
            pubid: this.pubid,
            utm_source: this.$route.query.utm_source,
            utm_campaign: this.$route.query.utm_campaign,
            utm_medium: this.$route.query.utm_medium,
            utm_content: this.$route.query.utm_content,
            utm_term: this.$route.query.utm_term,
            ua_device: this.$store.state.ua_device,
            ua_browser: this.$store.state.ua_browser,
            ua_os: this.$store.state.ua_os,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => console.log(error));
    },
};
</script>
<style>

</style>
